import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "../../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../../Models/GameModel";
import { AnimationContents } from "../../AnimationContents";
import { GameLogic } from "../../../Logic/GameLogic";
import { LocalizationContents } from "../../../LocalizationContents";

export class TapToPlayScreenController extends AnimationBaseController {
    $model: GameModel;

    private _titleWidth: number = 0;
    private _titleMargin: number = 100;

    public constructor(@Inject private _options: any,
        @Inject private _gameLogic: GameLogic) {
        super("TapToPlayScreenController");
        console.log('TapToPlayScreenController', this);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: "tap_to_play_screen",
            childControllers: {},
            modelWatch: {},
            onTap: () => {
                this.$model.tapToStart = false;
                this._gameLogic.hideModal();
            },
        };
    }

    protected onInitialize(): void {
        this.display.interactiveChildren = false;
        this.display.interactive = false;

        const title = this.getDisplayObjectByQuery('text')[0] as PIXI.Text;

        title.anchor.set(0.5, 0.2);
        title.x = 0;

        this.setTextByQuery('text', LocalizationContents.tap_to_start.toUpperCase());
        this.setTextStyleByQuery('text', {
            stroke: '#000000',
            strokeThickness: 16,
        });

        this._titleWidth = PIXI.TextMetrics.measureText(title.text, title.style).width;
    }

    protected onResize(width: number, height: number, scale: number) {
        const titleScale = Math.min(1, width / scale / (this._titleWidth + this._titleMargin));

        this.setScaleByQuery('text', titleScale, titleScale);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}

